import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import {FormattedDate} from 'react-intl';

class CustomerHistory extends React.PureComponent {
    constructor(props, context) {
        super(props, context);   

        this.loadHistory = this
            .loadHistory
            .bind(this); 
    }

    loadHistory(){
        const {workOrderActions, orderId, orderDetail} = this.props;
        const addressId = orderDetail.getIn(['schedulingSystemDetails', 'details', 'addressInfo', 'addressId']);
        workOrderActions.getOrderHistoryStarted({addressId : addressId}, orderId);
    }

    render() {   
        const {orderDetail} = this.props;
        const styles = {
            margin: {margin: '10px', padding: '0px'},
            label: {
                fontWeight: 'bold',
                padding: '5px'
            },
            displayValue: {
                padding: '5px'
            }
        };

        const customerHistory = orderDetail.get('addressHistory');

        let isError = false;
        let historyDetails = null;
        let hasDetails = false;


        const loadHistoryButton = (
            <div className="row">
                <div className="col s12">
                    <RaisedButton
                        style={{
                        margin: '5px'
                    }}
                        id="wow-fst-get-history-button"
                        disabled={false}
                        fullWidth
                        label="Load Customer History"
                        primary={true}
                        onTouchTap={this.loadHistory}/>
                </div>
            </div>
        );

        if(customerHistory){
            isError = customerHistory.get('isError');
            historyDetails = customerHistory.get('details');
            hasDetails = historyDetails && historyDetails.length > 0;
        } 

        let pastOrders = null;
        if(hasDetails){
            pastOrders = historyDetails.map((item, index) => {                 
                return (                    
                    <div key={'customerHistoryItem_' + index}>                     
                        <div className="row">
                            <span style={styles.label}>Date:</span> 
                            <span style={styles.displayValue}><FormattedDate value={item.scheduledDate}/></span>
                            <span style={styles.displayValue}>{item.timeWindow}</span><span style={styles.label}>Duration:</span>
                            <span style={styles.displayValue}>{item.duration}</span>                                                   
                        </div>
                        <div className="row">
                            <span style={styles.label}>WO#:</span>
                            <span style={styles.displayValue}> {item.workOrder}</span> 
                            <span style={styles.label}>ServiceType:</span> 
                            <span style={styles.displayValue}>{item.serviceType} / {item.serviceTypeDescription}</span>                     
                        </div>
                        <div className="row">
                            <span style={styles.label}>Tech:</span>
                            <span style={styles.displayValue}>{item.tech}</span>
                            <span style={styles.label}>Solution: </span>
                            <span style={styles.displayValue}>{item.primarySolutionCode}</span>
                            <span style={styles.label}>Status:</span>
                            <span style={styles.displayValue}>{item.orderStatus}</span>                 
                        </div>
                        <br />                                                                
                    </div>
                );            

            });
           
        }       

        let errorDisplay = null;
        if(isError){
            errorDisplay = (
                <div className="row">
                    <div>An error occurred while retrieving history</div>
                </div>
            );
        }    

        return (
             <div style={styles.margin}>           
                 {loadHistoryButton}      
                 {errorDisplay}
                 <Divider /> 
                 {pastOrders}
             </div>     
        );
    }
}

CustomerHistory.propTypes = {
    orderDetail: PropTypes.object,
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object
};

export default CustomerHistory;



// WEBPACK FOOTER //
// ./src/components/account/CustomerHistory.js